module.exports = __webpack_public_path__ + "static/pyohio-2019-transparent-300x225-cf84acdd90bd3ea6dd9ec9c7b896719f.png";